import { render, staticRenderFns } from "./ecobox.vue?vue&type=template&id=306b048f&scoped=true&"
import script from "./ecobox.vue?vue&type=script&lang=js&"
export * from "./ecobox.vue?vue&type=script&lang=js&"
import style0 from "./ecobox.vue?vue&type=style&index=0&id=306b048f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306b048f",
  null
  
)

export default component.exports